// ============================================
// 404 Not Found Page
// ============================================

import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaExclamationTriangle } from 'react-icons/fa';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="notfound-page">
      <div className="notfound-content">
        <FaExclamationTriangle className="error-icon" />
        <h1>404</h1>
        <h2>ไม่พบหน้าที่คุณต้องการ</h2>
        <p>ขออภัย หน้าที่คุณกำลังมองหาไม่มีอยู่ในระบบ</p>
        <Link to="/" className="btn btn-primary">
          <FaHome /> กลับหน้าแรก
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
